import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#1976D2',
        primarytwo: '#1565C0', 
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#F44336',
        info: '#2196F3',
        success: '#054a29',
        warning: '#FFC107',
        colorErrorLocal: '#7B1FA2',
        colorErrorServer: "#D32F2F",
        colorBotonAdd:'#FF9800',
        colorBotonEdit:'#2196F3',
        colorBotonDelete:'#9C27B0',
        colorBotonActivate:'#4CAF50',
        colorBotonEnabled:'#F44336',

      },
    },
  },
});
